import DateRangePicker from 'rsuite/DateRangePicker'
import styled from "styled-components";

export const StyledDateRangePicker = styled(DateRangePicker)`
    width: 100%;
`